import React from 'react';
import './MoodIcon.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logComponent from '../../common/logComponent';

export default function MoodIcon({ mood }) {
  if (logComponent('MoodIcon')) { console.debug('MoodIcon render'); }
  
  const getIcon = () => {

    mood = !mood ? 'ban' : mood.toString();

    switch(mood) {
      case '0': 
        return 'ban';
      case '1':
      case '2':
      case '3':
        return ['far', 'frown'];
      case '4':
      case '5':
      case '6':
        return ['far', 'meh'];
      case '7':
      case '8':
        return ['far', 'smile'];
      case '9':
        return ['far', 'grin'];
      case '10':
        return ['far', 'grin-beam'];
      default:
        return 'ban';
    }
  }


    return (
      <div className="Mood-Icon">
        <FontAwesomeIcon icon={ getIcon() } className={`Mood-Icon__mood-${mood}`} />
      </div>
    );
}